import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getRelatedBlogs } from "./relatedBlogsApi";

const initialState = {
    isLoading: false,
    isError: false,
    blogs: [],
    error: ""
}

export const fetchRelatedBlogs = createAsyncThunk("relatedBlogs/fetchRelatedBlogs", async({id, tags}) => {
    const blogs = getRelatedBlogs({tags, id});
    return blogs;
})

const relatedBlogsSlice = createSlice({
    name: "relatedBlogs",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchRelatedBlogs.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
            state.error = ""
        })
        builder.addCase(fetchRelatedBlogs.fulfilled, (state, action) => {
            state.isLoading = false;
            state.blogs = action.payload
        })
        builder.addCase(fetchRelatedBlogs.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.blogs = []
            state.error = action.error.message
        })
    }
})

export default relatedBlogsSlice.reducer;